import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { Container } from '@/components/generals/container'
import { Logo } from '@/components/generals/logo'
import { CookieSettingsButton } from '@/components/generals/cookie-settings-button'

import { siteConfig } from '@/constants/site'
import { FOOTER_EXPLORE, HUB_LINKS } from '@/constants/navigation'

export const SiteFooter: FC = (): ReactNode => {
    const year = new Date().getFullYear()

    return (
        <footer className='mt-24 border-t border-border bg-secondary/40'>
            <Container className='py-14'>
                <div className='grid gap-10 sm:grid-cols-2 lg:grid-cols-12'>
                    <div className='lg:col-span-5'>
                        <Logo />

                        <p className='mt-4 max-w-sm text-sm leading-relaxed text-muted-foreground'>
                            {siteConfig.name} publishes clear, evidence-based dental guides across cosmetic,
                            preventive, and general dentistry, written for patients in plain English.
                        </p>
                    </div>

                    <div className='lg:col-span-3'>
                        <h2 className='text-xs font-semibold uppercase tracking-wider text-foreground'>
                            Topic hubs
                        </h2>

                        <ul className='mt-4 space-y-2.5'>
                            {HUB_LINKS.map(link => (
                                <li key={link.href}>
                                    <Link
                                        href={link.href}
                                        className='text-sm text-muted-foreground transition-colors hover:text-primary'
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className='lg:col-span-4'>
                        <h2 className='text-xs font-semibold uppercase tracking-wider text-foreground'>
                            Explore
                        </h2>

                        <ul className='mt-4 space-y-2.5'>
                            {FOOTER_EXPLORE.map(link => (
                                <li key={link.href}>
                                    <Link
                                        href={link.href}
                                        className='text-sm text-muted-foreground transition-colors hover:text-primary'
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className='mt-12 border-t border-border pt-6'>
                    <p className='text-xs leading-relaxed text-muted-foreground'>
                        <span className='font-semibold text-foreground'>Medical disclaimer:</span> The content
                        on {siteConfig.domain} is for general informational purposes only and is not a substitute
                        for professional dental or medical advice, diagnosis, or treatment. Always consult a
                        qualified dentist about your individual circumstances.
                    </p>

                    <div className='mt-4 flex flex-col gap-2 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between'>
                        <p>© {year} {siteConfig.name}. All rights reserved.</p>

                        <div className='flex items-center gap-4'>
                            <Link href='/privacy' className='transition-colors hover:text-primary'>
                                Privacy
                            </Link>

                            <CookieSettingsButton />
                        </div>
                    </div>
                </div>
            </Container>
        </footer>
    )
}
